import React, { useState } from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../Icon";
import Modal from "../../../Modal";
import Schedule from "../../../Schedule";
import { useHistory } from "react-router";
import { ValidatorCollection } from "../../../../Services/assets/collection-validator";
import { ToastEmitter } from "../../../../Services/assets/toast-emitter";

const Control = ({
	className,
	startDate,
	setStartDate,
	onOpen,
	item,
	Submit,
	isLoading,
}) => {
	const [visibleModal, setVisibleModal] = useState(false);
	const history = useHistory();
	const actions =
		item.status === "DRAFT"
			? [
					{
						txt: "Publish",
						action: () => {
							const missingFields = ValidatorCollection(item);
							if (Object.keys(missingFields).length === 0) {
								setVisibleModal(true);
							} else {
								ToastEmitter({
									type: "info",
									msg: "You cannot publish a collection that has missing fields",
								});
							}
						},
					},
					{
						txt: "Edit",
						action: () => history.push("/products/edit/" + item._id),
					},
					{
						txt: "Delete",
						action: () => console.log("Delete forever"),
					},
			  ]
			: [
					{
						txt: "Unpublish",
						action: onOpen,
					},
			  ];

	return (
		<>
			<div className={cn(styles.control, className)}>
				{actions.map((x, index) => (
					<button
						className={cn(
							`button-small button-stroke${
								x.txt === "Delete" || x.txt === "Unpublish" ? "-red" : ""
							}`
						)}
						key={"tppmmm" + index}
						onClick={x.action}
					>
						{x.txt}
					</button>
				))}
			</div>
			<Modal visible={visibleModal} onClose={() => setVisibleModal(false)}>
				<Schedule
					isLoading={isLoading}
					action="Publish"
					onClick={Submit}
					startDate={startDate}
					setStartDate={setStartDate}
				/>
			</Modal>
		</>
	);
};

export default Control;
